import {Pipe, PipeTransform} from '@angular/core';
import {Util} from "../../app/util";

/**
 * Generated class for the DinheiroPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
    name: 'dinheiro',
})
export class DinheiroPipe implements PipeTransform {

    constructor(public util: Util) {


    }

    transform(value: number, cents: boolean = true, abs: boolean = false) { // ...args -> quando aceita infinitos argumentos?

        //todo: vamos usar assim?? ou dentro da dinheiro() vamos colocar assim?
        //return new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(value);

        if (abs) value = Math.abs(value);
        return this.util.dinheiro(value, cents);

    }

}



// WEBPACK FOOTER //
// ./src/pipes/dinheiro/dinheiro.ts